export var RelationshipFetchOption;
(function (RelationshipFetchOption) {
    RelationshipFetchOption["DATA_FOR_SCHEDULING_FLOW"] = "dataForSchedulingFlow";
    RelationshipFetchOption["DATA_FOR_PATIENT_DOB_VALIDATION"] = "dataForPatientDOBValidation";
})(RelationshipFetchOption || (RelationshipFetchOption = {}));
//# sourceMappingURL=maps.js.map